var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DefaultButton, Stack, useTheme } from "@fluentui/react";
import React, { useId } from "react";
import { getDisplayFlex } from "../EvolvedSettingsDialog.styles";
import { getActionInfoContentStyles, getActionMainButtonStyle } from "./EvolvedSettingsAction.styles";
// A Expand/Collapse UX Component for the DMA Settings Work.
const EvolvedSettingsInfoButton = React.memo((_a) => {
    var { styles, content, actionNode } = _a, rest = __rest(_a, ["styles", "content", "actionNode"]);
    const theme = useTheme();
    const id = "info-button-setting-" + useId();
    return React.createElement(DefaultButton, Object.assign({ uniqueId: id, styles: getDisplayFlex(getActionMainButtonStyle(theme)) }, rest),
        React.createElement(Stack.Item, { grow: true, styles: getDisplayFlex(getActionInfoContentStyles(theme, false)) }, content),
        actionNode);
});
export default EvolvedSettingsInfoButton;
